// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ImageWithPlaceholder_imageContainer__59IPy","image":"ImageWithPlaceholder_image__2sTsD","loadingPlaceholder":"ImageWithPlaceholder_loadingPlaceholder__1k8Pl"};